import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { HomeComponent } from './components/pages/home/home.component';
import { LoginComponent } from './components/pages/login/login.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { AuthService } from './services/auth.service';
import { CanLoginGuard } from './guards/can-login.guard';
import { NavbarModule } from './components/shared/navbar/navbar.module';
import { DailyComponent } from './components/pages/daily/daily.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { ReliefsComponent } from './components/pages/reliefs/reliefs.component';
import { ForgotPasswordComponent } from './components/pages/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/pages/verify-email/verify-email.component';
import { LandingComponent } from './components/pages/landing/landing.component';
import { ThankyouComponent } from './components/pages/thankyou/thankyou.component';
import { PrivacyPolicyComponent } from './components/shared/privacy-policy/privacy-policy.component';
import { PrivacyLinkComponent } from './components/shared/privacy-link/privacy-link.component';
import { ServiceWorkerModule } from '@angular/service-worker';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ProfileComponent,
    DailyComponent,
    RegisterComponent,
    ReliefsComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    LandingComponent,
    ThankyouComponent,
    PrivacyPolicyComponent,
    PrivacyLinkComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    ReactiveFormsModule,
    NavbarModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    AuthService,
    CanLoginGuard
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
